import { render, staticRenderFns } from "./confirmKeyword.vue?vue&type=template&id=44096fd3&scoped=true"
import script from "./confirmKeyword.vue?vue&type=script&lang=js"
export * from "./confirmKeyword.vue?vue&type=script&lang=js"
import style0 from "./confirmKeyword.vue?vue&type=style&index=0&id=44096fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44096fd3",
  null
  
)

export default component.exports